export default __webpack_public_path__ + "static/media/logo.835b14fb.svg";